import React, { useState } from 'react';
import moment from 'moment';
import { Tabs, Button, Card, Typography, Tag } from 'antd';

const { Text } = Typography;

const SlotTabs = ({ data, onSlotSelection }) => {
    const [selectedSlot, setSelectedSlot] = useState(null);

    const buildTabItems = () => {
        const now = moment();

        return Object.entries(data)
            .map(([dateKey, slots]) => {
                const upcomingSlots = slots.filter(slot =>
                    moment(slot.slotTime).isSameOrAfter(now)
                );

                if (upcomingSlots.length === 0) return null;

                const isSelectedInThisTab =
                    selectedSlot &&
                    moment(selectedSlot.slotTime).isSame(dateKey, 'day');

                return {
                    key: dateKey,
                    label: moment(dateKey).format('ddd, MMM D'),
                    children: (
                        <div className="p-2">
                            <div className="d-flex flex-wrap justify-content-center">
                                {upcomingSlots.map((slot, index) => (
                                    <div key={index} className="d-flex flex-column align-items-center m-1">
                                        <Button
                                            style={{ width: 115, height: 'auto', padding: '4px 8px' }}
                                            disabled={slot.slots.count === 0}
                                            type={
                                                selectedSlot?.slotTime === slot.slotTime
                                                    ? 'primary'
                                                    : 'default'
                                            }
                                            onClick={() => {
                                                setSelectedSlot(slot);
                                                onSlotSelection(slot);
                                            }}
                                        >
                                            <div>{moment(slot.slotTime).format('hh:mm A')}</div>
                                            {slot.tag === 'low wait time' && (
                                               <div style={{ fontSize: 9, color: '#52c41a', fontWeight: 'bold' }}>Low wait time</div>
                                            )}
                                            {slot.slots.regional && (
                                               <div style={{ fontSize: 9, color: '#1890ff', fontWeight: 'bold' }}>Regional</div>
                                            )}
                                        </Button>
                                    </div>
                                ))}
                            </div>
                        </div>
                    )
                };
            })
            .filter(Boolean); // Remove nulls
    };

    const tabItems = buildTabItems();

    if (tabItems.length === 0) {
        return <Text>No upcoming slots available.</Text>;
    }

    return (
        <div style={{ width: '98%' }}>
            <Tabs
                items={tabItems}
                type="card"
                size="small"
                defaultActiveKey={tabItems[0].key}
            />
        </div>
    );
};

export default SlotTabs;
